// Tampilan resit yang dipakai ulang: pratonton sebelum sahkan & resit terbit.
// mode: 'thermal' (80mm) | 'a4'
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { formatRM } from '../lib/format';

export const RESIT_CSS = `
.resit-box { margin:0 auto; }
.resit-thermal { width:76mm; font-family:'JetBrains Mono',monospace; font-size:11px; line-height:1.5; }
.resit-a4 { width:100%; max-width:600px; font-family:'JetBrains Mono',monospace; font-size:14px; line-height:1.7; }
.resit-box .dash { border:none; border-top:1px dashed currentColor; opacity:0.3; margin:8px 0; }
.resit-box .rrow { display:flex; justify-content:space-between; gap:8px; }
.resit-box .rtotal { font-weight:700; font-size:1.25em; }
.resit-box .rcenter { text-align:center; }
`;

const KAEDAH = { tunai: 'Tunai', transfer: 'Pindahan Bank', qr_manual: 'QR Manual' };

export default function ResitView({ resit, school, mode = 'thermal', estimate = false }) {
  const { t } = useTranslation();
  if (!resit) return null;
  const tarikh = new Date(resit.tanggal).toLocaleString('ms-MY', { dateStyle: 'medium', timeStyle: 'short' });
  return (
    <div className={`print-area resit-box ${mode === 'thermal' ? 'resit-thermal' : 'resit-a4'} border border-border rounded-lg p-4 bg-white dark:bg-card text-slate-900 dark:text-foreground`}>
      {estimate && (
        <div className="rcenter mb-2 text-[11px] font-sans font-semibold text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-950 border border-amber-200 dark:border-amber-800 rounded px-2 py-1">
          {t('pratontonResit')}
        </div>
      )}
      <div className="rcenter">
        <img src="/mtsrpay-logo.webp" alt="MTSRpay" style={{ height: 40, margin: '0 auto 6px' }} />
        <div style={{ fontWeight: 700 }}>{school?.nama || 'MTSRpay'}</div>
        {school?.alamat && <div style={{ fontSize: '0.9em' }}>{school.alamat}</div>}
        {school?.telefon && <div style={{ fontSize: '0.9em' }}>Tel: {school.telefon}</div>}
      </div>
      <hr className="dash" />
      <div className="rrow"><span>No. Resit</span><span>{resit.no_resit}</span></div>
      <div className="rrow"><span>Tarikh</span><span>{tarikh}</span></div>
      <div className="rrow"><span>Pelajar</span><span>{resit.studentNama}</span></div>
      <div className="rrow"><span>Kelas</span><span>{resit.kelas}</span></div>
      <hr className="dash" />
      <div className="rrow"><span>{resit.tarifNama}</span><span>{formatRM(resit.amount)}</span></div>
      {resit.diskonNota && <div className="rrow"><span>Diskaun</span><span>{resit.diskonNota}</span></div>}
      <hr className="dash" />
      <div className="rrow rtotal"><span>JUMLAH</span><span>{formatRM(resit.amount)}</span></div>
      <div className="rrow"><span>Kaedah</span><span>{KAEDAH[resit.kaedah] || resit.kaedah}</span></div>
      {resit.penyemak && <div className="rrow"><span>Disemak</span><span>{resit.penyemak}</span></div>}
      {resit.baki > 0 && <div className="rrow"><span>Baki tertunggak</span><span>{formatRM(resit.baki)}</span></div>}
      <hr className="dash" />
      <div className="rcenter" style={{ fontSize: '0.9em' }}>Terima kasih. Simpan resit ini sebagai bukti pembayaran.</div>
      {!estimate && resit.no_resit && (
        <div className="rcenter" style={{ marginTop: 8 }}>
          <QRCodeSVG
            value={`${typeof window !== 'undefined' ? window.location.origin : ''}/verifikasi/${encodeURIComponent(resit.no_resit)}`}
            size={96}
            style={{ margin: '0 auto' }}
          />
          <div style={{ fontSize: '0.8em', marginTop: 4 }}>{t('imbasQrResit')}</div>
        </div>
      )}
    </div>
  );
}
